// Module
var code = "404 ";
// Exports
module.exports = code;